import clsx from 'clsx';

import { AnimateModal, ModalOpenProps } from '@/components/ui/modal';
import { NEW_PIPE_LENGTH_TITLE, SELECT_MORE_SYSTEM } from '@/config';

import { useNormalView } from '../hooks/useNormalView';
import { usePipeLength } from '../hooks/usePipeLength';
import { CreateMoreSystems, DuctDynaFields } from '../inputs';
import { CATALOGUE_CATEGORY as CAT, TKSystem, LENGTH_TYPE } from '../types';

type PipeLenthProps = ModalOpenProps & {
  /**
   * LENGTH_TYPE.P
   */
  selectType: string;
  systems: TKSystem[];
  unit?: string;
};

/** Create Pipe Length Modal */
export const AddPipeLengh = ({
  isOpen,
  isOnStage,
  systems,
  unit,
  selectType,
  lazyCloseHandler,
}: PipeLenthProps) => {
  const { isNormalView, setIsNormalView, normalView, backToNormal } =
    useNormalView();
  const upl = usePipeLength(lazyCloseHandler);
  return (
    <AnimateModal
      isOpen={isOpen}
      isOnStage={isOnStage}
      lazyCloseHandler={lazyCloseHandler}
      title={isNormalView ? NEW_PIPE_LENGTH_TITLE : SELECT_MORE_SYSTEM}
      innerViewSwitchHandler={isNormalView ? undefined : backToNormal}
    >
      {/* == system field == */}
      <CreateMoreSystems
        systems={systems}
        category={CAT.P}
        itemType={selectType}
        forceToNormal={isNormalView}
        currentSystem={upl.currentSystem}
        currentSystemChangeHandler={upl.setCurrentSystem}
        onMoreSystemSwitch={setIsNormalView}
      />
      {/* == make fields dynamic rendered by definition @2025/04/22 */}
      <div className={normalView('flex flex-wrap my-0 gap-0')}>
        <DuctDynaFields
          defaultValues={upl.fieldProps}
          fields={upl.pipeLengthFields}
          fieldRenderer={upl.inputFieldRenderer}
          unit={unit}
          itemType={LENGTH_TYPE.P}
        />
      </div>
      {/* button row */}
      <div className="flex gap-x-10 justify-between mx-0 mt-6">
        {/* close modal */}
        <button
          className="btn-red-border color-red font-semibold flex-1 red-shadow"
          onClick={upl.cancelNewElementHandler}
        >
          Cancel
        </button>
        {/* save button */}
        <button
          className={clsx(
            'btn-green flex-1 leading-5 text-base bg-green shadow-md',
          )}
          onClick={upl.applyNewElementHandler}
        >
          Apply
        </button>
      </div>
    </AnimateModal>
  );
};
